import { createSlice } from '@reduxjs/toolkit';

// Slice
const initialState = {
    filterValues: null,
    manufacturersList: null,
    certificateTypes: [],
};

const slice = createSlice({
    name: 'addCertificate',
    initialState,
    reducers: {
        setFilterValuesInfo: (state, action) => {
            state.filterValues = action.payload;
        },
        setManufacturersList: (state, action) => {
            state.manufacturersList = action.payload;
        },
        formReset: (state, action) => {
            state.form = null;
        },
        setCertificateTypesInfo: (state, action) => {
            state.certificateTypes = [...action.payload];
        }
    },
});

export default slice.reducer;

// Actions
const { setFilterValuesInfo, setManufacturersList, formReset, setCertificateTypesInfo } = slice.actions;

export const setFilterValues = (payload) => async dispatch => {
    try {
        dispatch(setFilterValuesInfo(payload));
    } catch (e) {
        return console.error(e.message);
    }
}

export const setManufacturers = (payload) => async dispatch => {
    try {
        dispatch(setManufacturersList(payload));
    } catch (e) {
        return console.error(e.message);
    }
}

export const resetForm = () => async dispatch => {
    try {
        return dispatch(formReset())
    } catch (e) {
        return console.error(e.message);
    }
}


export const setCertificateTypes = (payload) => async dispatch => {
    try {
        dispatch(setCertificateTypesInfo(payload));
    } catch (e) {
        return console.error(e.message);
    }
}